/* ===== idetox LP – JS v3 with enhancements ===== */

// Scroll Reveal Animation
(() => {
  const revealElements = document.querySelectorAll('[data-reveal]');
  if (!revealElements.length) return;

  const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  // IntersectionObserverが利用可能かチェック
  if (!('IntersectionObserver' in window) || prefersReducedMotion) {
    // 利用できない場合は、PC/スマホ問わず全て表示
    revealElements.forEach(el => {
      const animationClass = el.dataset.animationClass || 'is-show';
      el.classList.add(animationClass);
    });
    return;
  }

  const observer = new IntersectionObserver(
    (entries, observer) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          const target = entry.target;
          const animationClass = target.dataset.animationClass || 'is-show';
          const configuredDelay = target.dataset.animationDelay ? parseInt(target.dataset.animationDelay, 10) : 0;
          const delay = Number.isNaN(configuredDelay) ? 0 : Math.min(configuredDelay, 80);

          if (delay > 0) {
            setTimeout(() => {
              target.classList.add(animationClass);
            }, delay);
          } else {
            target.classList.add(animationClass);
          }

          observer.unobserve(target); // 一度表示されたら監視を停止
        }
      });
    },
    {
      rootMargin: '0px 0px 15% 0px', // 少し早めに発火してスクロール待ちを減らす
      threshold: 0.05 // 要素が少し入った時点で発火
    }
  );

  // すべての[data-reveal]要素を監視
  revealElements.forEach(el => observer.observe(el));
})();

// FAQ smooth scroll on mobile
document.addEventListener('click', e => {
  if (e.target.tagName.toLowerCase() === 'summary') {
    const details = e.target.parentElement;
    setTimeout(() => {
      if (details.open && window.innerWidth < 768) {
        details.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    }, 200);
  }
});

// Hide sticky CTA when footer in view
(() => {
  const cta = document.querySelector('.business-sticky-cta');
  const footer = document.querySelector('footer');

  if (!cta || !footer || !('IntersectionObserver' in window)) return;

  const io = new IntersectionObserver(
    ([entry]) => {
      cta.style.transform = entry.isIntersecting ? 'translateY(100%)' : 'translateY(0)';
    },
    { threshold: 0 }
  );
  io.observe(footer);
})();

// Business Services Accordion
(() => {
  const serviceItems = document.querySelectorAll('.business-services .service-item');
  const pcBreakpoint = 769; // PCとスマホのブレークポイント (CSSと合わせる)

  serviceItems.forEach(item => {
    const header = item.querySelector('.service-item-header');
    if (header) {
      header.addEventListener('click', () => {
        if (window.innerWidth >= pcBreakpoint) {
          // PCの場合：全てのサービス項目を展開/折りたたみ
          const isExpanded = item.classList.contains('is-expanded');
          serviceItems.forEach(serviceItem => {
            if (isExpanded) {
              serviceItem.classList.remove('is-expanded');
            } else {
              serviceItem.classList.add('is-expanded');
            }
          });
        } else {
          // スマホの場合：クリックされた項目のみ展開/折りたたみ
          item.classList.toggle('is-expanded');
        }
      });
    }
  });
})();
